import { render, staticRenderFns } from "./KanbanSkeleton.vue?vue&type=template&id=1767285d&scoped=true"
import script from "./KanbanSkeleton.vue?vue&type=script&lang=js"
export * from "./KanbanSkeleton.vue?vue&type=script&lang=js"
import style0 from "./KanbanSkeleton.vue?vue&type=style&index=0&id=1767285d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1767285d",
  null
  
)

export default component.exports